import { Button, Col, Form } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import "../../../css/newitempage.css"
import React, {Component} from 'react';
import Select from 'react-select'
import { make_select_data } from "../../helper";

class NewType extends Component{
    constructor(){
        super();
        this.state = {
            name: "",
            display_name:"",
            is_stb_type:false,
            is_create_stb : false,
            is_create_internet : false,
            is_remove_stb : false,
            is_remove_internet : false,
            is_replace_internet : false,
            is_replace_stb: false,
            contracts_array:[],
            selected_contract:null,
            selected_contract_id:null,
            errors:{
                name:false,
                display_name:false
            },
            modal:false,
            error_messages:{
                name_error_message:'გთხოვთ შეიყვანოთ ტიპი',
                display_name_error_message:""
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'ტიპი წარმატებით ჩაემატა'
            }
        }
    }

    componentDidMount(){
        this.fetch_ticket_contracts();
        let type_id = this.props.match.params.id

        if(type_id){
            this.fetch_type(type_id);
        }
    }

    fetch_type(type_id){
        axiosInstance.get('tickets/types/' + type_id)
        .then(response => response.data.data)
        .then(data => {
            this.setState({
                name : data.name,
                display_name: data.display_name,
                is_stb_type : data.is_stb_type_bool,
                selected_contract_id : data.contract_id,
                is_create_stb : data.is_create_stb,
                is_create_internet :  data.is_create_internet,
                is_remove_stb :  data.is_remove_stb,
                is_remove_internet :  data.is_remove_internet,
                is_replace_internet :  data.is_replace_internet,
                is_replace_stb:  data.is_replace_stb,
            });
            this.selected_contract();
        })
        .catch(err => {
            console.log(err);
        })
    }

    fetch_ticket_contracts(){
        axiosInstance.get("tickets/types/contracts")
        .then(response =>{
            this.setState({
                contracts_array:make_select_data(response.data.data)
            })
        })
        .catch(err =>  {
            console.log(err)
            if(err.response != null){
                if(err.response.status === 401){
                    this.logout();
                }
            }
            
        })
    }

    after_fetch_contacts(data){
        var contracts_array = [];
        data.forEach(function(element){
            contracts_array.push({
                value:element.id,
                label:element.display_name
            })
        });

        this.setState({
            contracts_array:contracts_array
        });
    }

    selected_contract(){
        let array  =  this.state.contracts_array.filter((element,_) => {
            return element.value == this.state.selected_contract_id;
        });

        this.setState({
            selected_contract : array
        })
    }

    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                },
                response : {
                    isValid : false,
                    isInValid:false,
                    message : 'ტიპი წარმატებით ჩაემატა'
                }
            }
        ) 
    }

    hadnleUnprocessableEntity(errors){
        let main_message = "";
        Object.keys(errors).map((key,index) => {
            let errors_array = errors[key];
            errors_array.map((message,_) => {
                main_message = main_message + message + '\n';
            })
        })
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:main_message
            }
        })
    }
    update_type(){
        axiosInstance.put('tickets/types/' + this.props.match.params.id,{
            "name" : this.state.name,
            "display_name" : this.state.display_name,
            "contract_type_id" : this.state.selected_contract_id,
            "is_stb_type" : this.state.is_stb_type,
            "is_create_stb" : this.state.is_create_stb,
            "is_create_internet" : this.state.is_create_internet,
            "is_remove_stb" : this.state.is_remove_stb,
            "is_remove_internet" : this.state.is_remove_internet,
            "is_replace_internet" : this.state.is_replace_internet,
            "is_replace_stb": this.state.is_replace_stb,
            
        })
        .then(response => response.data)
        .then(data => {
            this.setState({
                response:{
                    ...this.state.response,
                    isValid:true,
                    message:data.message
                }
            })
        })
        .catch(err => {
            if(err?.response?.status == 422){
                this.hadnleUnprocessableEntity(err.response.data.errors); 
            }
        })
    }

    on_type_added(data){
        this.setState({
            response:{
                ...this.state.response,
                isValid:true,
                message:data.message
            }
        })
    }
    add_type_btn_clicked(event){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:false,
                isValid:false,
                message:''
            }
        })
        if(this.valid()){
            axiosInstance.post('tickets/types', {
                "name" : this.state.name,
                "display_name" : this.state.display_name,
                "contract_type_id" : this.state.selected_contract_id,
                "is_stb_type":this.state.is_stb_type
            })
            .then(response=>{
                this.setState({
                    response:{
                        ...this.state.response,
                        isValid:true,
                        message:response.data.message
                    }
                })
            })
            .catch(error => {
                if(error.response?.status == 400 || error.response?.status == 422){
                    this.on_bad_request(error);
                }
            });
        }
    }

    valid(){
        var name = (this.state.name === "");
        var display_name = (this.state.display_name === "");
        if(name ||display_name ){
            this.setState({
                errors:{
                    name:name,
                    display_name:display_name
                },
            })
            return false;
        }
        return true;
    }

    on_bad_request(error){
        this.setState({     
            response:{
                ...this.state.response,
                isInValid:true,
                message:error.response.data.message
            }
        })
    }

    on_contract_changed(e){
        this.setState({
            selected_contract:e,
            selected_contract_id:e.value
        });
    }
    render(){
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    type="text"
                                    name="type"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>სახელი ლათინურად</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.name)}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>სახელი გამოსაჩენად</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="display_name"
                                    value = {this.state.display_name}
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.display_name)}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.display_name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>კონტრაქტი</Form.Label>
                            <Form.Control
                                    type="text"
                                    name="contract"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.errors.contract)}
                                    onChange = {null}
                                />
                            <Select 
                                value = {this.state.selected_contract}
                                options={this.state.contracts_array} 
                                onChange={(e)=>this.on_contract_changed(e) } 
                                placeholder = "აირჩიეთ კონტრაქტი"
                             />
                            <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.contract_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}  md="2" >
                        <Form.Check checked={this.state.is_stb_type} type="checkbox" label="stb type" onChange={(e) => {
                            this.setState({
                                is_stb_type:e.target.checked
                            })
                        }} />
                    </Form.Group>
                    <Form.Group as={Col}  md="2" >
                        <Form.Check checked={this.state.is_create_stb} type="checkbox" label="STB-დადგმა" onChange={(e) => {
                            this.setState({
                                is_create_stb:e.target.checked
                            })
                        }} />
                    </Form.Group>
                    <Form.Group as={Col}  md="2" >
                        <Form.Check checked={this.state.is_create_internet} type="checkbox" label="INTERNET-დადგმა" onChange={(e) => {
                            this.setState({
                                is_create_internet:e.target.checked
                            })
                        }} />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                <Form.Group as={Col}  md="2">
                        <Form.Check checked={this.state.is_remove_stb} type="checkbox" label="STB-მოხსნა" onChange={(e) => {
                            this.setState({
                                is_remove_stb:e.target.checked
                            })
                        }} />
                    </Form.Group>
                    <Form.Group as={Col}  md="2">
                        <Form.Check checked={this.state.is_remove_internet} type="checkbox" label="INTERNET მოხსნა" onChange={(e) => {
                            this.setState({
                                is_remove_internet:e.target.checked
                            })
                        }} />
                    </Form.Group>
                    <Form.Group as={Col}  md="2">
                        <Form.Check checked={this.state.is_replace_stb} type="checkbox" label="STB-შეცვლა" onChange={(e) => {
                            this.setState({
                                is_replace_stb:e.target.checked
                            })
                        }} />
                    </Form.Group>
                    <Form.Group as={Col}  md="2">
                        <Form.Check checked={this.state.is_replace_internet} type="checkbox" label="INTERNET-შეცვლა" onChange={(e) => {
                            this.setState({
                                is_replace_internet:e.target.checked
                            })
                        }} />
                    </Form.Group>
                </Form.Row>
                <Link  to = "/types"  id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                {!this.props.match.params.id &&<Button className="btn btn-success"  size="md" onClick={(event)=>this.add_type_btn_clicked(event)}>დამატება</Button>}
                {this.props.match.params.id && <Button className="btn btn-success"  size="md" onClick={(event)=>this.update_type(event)}>რედაქტირება</Button>}
            </div>
        )
    }
}
export default withRouter(NewType);